/**
 * This is group-details script.js file
 */

import ActionsDetail from '@/components/actions-detail';
import DispatchersMixin from '@/mixins/dispatchers';
import ElementList from '@/components/element-list';
import FormWatcher from '@/inheritance/form-watcher';


export default {
    name: 'GroupDetail',
    mixins: [DispatchersMixin],
    extends: FormWatcher,

    props: {
        id: {
            type: String,
            required: false
        }
    },
    components: {
        ElementList,
        ActionsDetail
    },
    watch: {
        $route: {
            /**
             * Comprobamos con un watch si la URL ha cambiado y obtenemos los datos
             */
            handler() {
                this.permissions = [];
                this.permissionSelected = null;
                this.saving = false;
                this.savingTitle = 'Guardar cambios';
                const sections = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS'))))).sections;
                this.userSections = {
                    userEdit: sections.find(x => x.key_name === 'USERS') ? sections.find(x => x.key_name === 'USERS').permission_object.value.edit : false,
                    userRead: sections.find(x => x.key_name === 'USERS') ? sections.find(x => x.key_name === 'USERS').permission_object.value.read : false,
                    psRead: sections.find(x => x.key_name === 'PERMISSION_SET') ? sections.find(x => x.key_name === 'PERMISSION_SET').permission_object.value.read : false,
                    psEdit: sections.find(x => x.key_name === 'PERMISSION_SET') ? sections.find(x => x.key_name === 'PERMISSION_SET').permission_object.value.edit : false
                };
                // Si hay datos en el estado los cargamos
                const storedComponentData = this.getStoredComponentData();
                if (storedComponentData && Object.keys(storedComponentData).length) {
                    Object.entries(storedComponentData).forEach(([key, value]) => this[key] = value);
                } else {
                    this.form = { permission_set: {}, users: [], _links: {} };
                }

                if (this.$route.name !== 'groups_add') {
                    // View/edit permission set
                    this.fetchData();
                } else {
                    this.loadCreate();
                }
            },
            immediate: true
        }
    },
    /**
     * @override
     */
    data() {
        return {
            form: { permission_set: {}, users: [] },
            permissions: [],
            permissionSelected: null,
            saving: false,
            savingTitle: 'Guardar cambios',
            addUsers: false,
            usersNotInGroup: [],
            loadingUsers: false,
            uuid_group: null,
            modalId: 'userChangeGroupWarning',
            changingUser: undefined,
            formWatcherProperties: ['form'],
            userSections: null
        };
    },
    methods: {
        /**
         * @override
         */
        loadCreate() {
            if (this.userSections.psRead) {
                this.$permissionService.getPermissions('key_name asc')
                    .then(res => {
                        this.permissions = res.data.permission_sets;
                        this.permissions = this.permissions.map(x => ({
                            value: x._links._self.href,
                            text: x.key_name,
                            uuid: x.uuid
                        }));
                        this.$store.dispatch('loaderStore/isVisible', false);
                    })
                    .catch(err => {
                        this.$toast.error(err.name, err.message);
                    });
            }
        },
        /**
         * Obtenemos la información del grupo
         */
        fetchData() {
            this.uuid_group = this.id || this.$route.params.uuid;
            this.loadGroup(this.uuid_group);
        },
        /**
         * Obtenemos el grupo desde el servicio
         * @param {String} uuid ID del grupo
         */
        loadGroup(uuid) {
            const cfg = {
                params: {
                    '$expand': 'users,permission_set'
                }
            };
            const promises = [
                this.$groupsService.getGroupsByUUId(uuid, cfg)
            ];
            if (this.userSections.psRead) {
                promises.push(this.$permissionService.getPermissions('key_name asc'));
            }
            Promise.all(promises)
                .then(res => {
                    this.form = res[0].data.group;
                    this.permissions = this.userSections.psRead ? res[1].data.permission_sets : [];
                    this.permissions = this.permissions.map(x => ({
                        value: x._links._self.href,
                        text: x.key_name,
                        uuid: x.uuid
                    }));
                    this.$store.dispatch('loaderStore/isVisible', false);
                })
                .catch(err => {
                    this.$toast.error(err.name, err.message);
                });
        },
        /**
         * Obtenemos usuarios que no están en el grupo
         * @param {String} uuid_group ID del grupo
         * @param {String} str Texto a buscar
         */
        filterUsersNotInGroup(uuid_group, str = '') {
            this.loadingUsers = true;
            const filters = {
                'uuid_group': [
                    { 'ne': `${uuid_group}` }
                ]
            };
            if (str && str !== '') {
                filters['given_name'] = [
                    { 'in': `%${str}%` }
                ];
            }

            const cfg = {
                params: {
                    '$filter': JSON.stringify(filters)
                }
            };

            this.$usersService.getUsers('given_name asc', cfg)
                .then(res => {
                    this.usersNotInGroup = res.data.users.map(x => {
                        return {
                            name: `${x.given_name} ${x.family_name_1} ${x.family_name_2 ? x.family_name_2 : ''}`,
                            uuid: x.uuid
                        };
                    });
                    this.loadingUsers = false;
                });
        },
        /**
         * Si estamos editando un grupo volvemos a los detalles de este grupo,
         * de lo contrario cerramos el tab actual y volvemos a los grupos
         */
        handleCancel() {
            this.deleteStoredComponentData();
            if (this.uuid_group) {
                this.$router.push({ name: 'groups_uuid', params: { uuid: this.uuid_group } });
            } else {
                const items = this.$store.getters['yuriMenuStore/items'];
                let indexMenu = 0;
                for (let index = 0; index < items.length; index++) {
                    const element = items[index];
                    if (element.route.name === 'groups_add') {
                        indexMenu = index;
                    }
                }
                const last = items.find(x => x.route.name === 'groups');
                if (last) {
                    this.$store.dispatch('yuriMenuStore/removeItem', indexMenu).then(() => {
                        this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
                            this.$router.replace(last.route);
                        });
                    });
                } else {
                    this.closeActiveTab('dashboard');
                }
            }
        },
        /**
        * Mostramos el modal de borrado
        */
        showDeletionModal() {
            this.$bvModal.show('modalRemove');
        },
        /**
         * Ocultamos el modal de borrado
         */
        hideDeletionModal() {
            this.$bvModal.hide('modalRemove');
        },
        /**
         * Borramos el group
         */
        deleteGroup() {
            this.$groupsService.deleteByUUIId(this.uuid_group)
                .then(response => {
                    this.$toast.success(`${response.result.http_code}`, `${'Grupo eliminado'}`);
                    const items = this.$store.getters['yuriMenuStore/items'];
                    let indexMenu = 0;
                    for (let index = 0; index < items.length; index++) {
                        const element = items[index];
                        if (element.route.name === 'groups_uuid') {
                            indexMenu = index;
                        }
                    }
                    const last = items.find(x => x.route.name === 'groups');
                    if (last) {
                        this.$store.dispatch('yuriMenuStore/removeItem', indexMenu).then(() => {
                            this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
                                this.$router.replace(last.route);
                            });
                        });
                    } else {
                        this.closeActiveTab('dashboard');
                    }
                })
                .catch(err => this.$toast.error(`Error ${err.name}`, `${'No se pudo eliminar el grupo'}`));
        },
        /**
         * Guardamos la información del grupo
         * Marco como 'undefined' los objetos obtenidos por $expand
         * @param {Event} e FormEvent
         */
        onSubmit(e) {
            e.preventDefault();
            this.saving = true;
            this.savingTitle = 'Guardando...';
            const metodo = this.$route.name !== 'groups_add' ?
                this.$groupsService.update
                : this.$groupsService.create;
            metodo(this.form)
                .then(response => {
                    this.updateItemMenu(response);
                })
                .catch(response => {
                    this.$toast.error(`Error ${response.name}`, `${response.message}`);
                })
                .finally(() => {
                    this.deleteStoredComponentData();
                    this.saving = false;
                    this.savingTitle = 'Guardar cambios';
                });
        },
        /**
         * Cambiamos el _link de permission_set
         * @param {String} e Url del permission set seleccionado
         */
        setPermission(e) {
            this.form.permission_set = e.split('/')[e.split('/').length - 1];
            this.form._links.permission_set = e;
        },
        /**
         * Actualizamos la pestaña actual del menú con el nuevo nombre
         * @override Resultado obtenido de la modificación para mostrar en el toast
         */
        updateItemMenu(res) {
            if (this.$route.name !== 'groups_add') {
                if (this.$route.meta && this.$route.meta.isView) {
                    this.$store.dispatch('yuriMenuStore/updateSubItemName', this.form.key_name)
                        .then(() => {
                            const query = Object.assign({}, this.$route.query);
                            delete query.edit;
                            this.$router.replace({ query })
                                .then(() => {
                                    this.deleteStoredComponentData();
                                    this.$toast.success(`Success`, `${res.result.info}`);
                                });
                        });

                } else {
                    // Pestaña menú principal
                    this.$store.dispatch('yuriMenuStore/updateItemName', this.form.key_name)
                        .then(() => {
                            this.$router.push({ name: 'groups_uuid', params: { uuid: this.uuid_group } });
                            this.deleteStoredComponentData();
                            this.$toast.success(`Success`, `${res.result.info}`);
                            this.fetchData();
                        });
                }
            } else {
                this.$toast.success(`${res.result.http_code}`, `${'Grupo añadido.'}`);
                const items = this.$store.getters['yuriMenuStore/items'];
                let indexMenu = 0;
                for (let index = 0; index < items.length; index++) {
                    const element = items[index];
                    if (element.route.name === 'groups_add') {
                        indexMenu = index;
                    }
                }
                const last = items.find(x => x.route.name === 'groups');
                if (last) {
                    this.$store.dispatch('yuriMenuStore/removeItem', indexMenu).then(() => {
                        this.$store.dispatch('yuriMenuStore/setActiveItem', last).then(() => {
                            this.$router.replace(last.route);
                        });
                    });
                } else {
                    this.closeActiveTab('dashboard');
                }
            }
        },
        /**
         * On search-change event handler
         * @param {Object} event Search query
         */
        onFilterUser(event) {
            this.filterUsersNotInGroup(this.uuid_group, event);
        },
        /**
         * Shows multiselect to add users to group
         */
        showAddUsersSelect() {
            this.addUsers = !this.addUsers;
            this.filterUsersNotInGroup(this.uuid_group);
        },
        /**
         * Adds user to group
         * @param {Object} user Selected user
         */
        onSelectUser(user) {
            this.changingUser = user;
            this.$bvModal.show(this.modalId);
        },
        /**
         * Change user and close modal
         * @param {Object} user User
         */
        acceptChangeUser(user) {
            this.$usersService.changeGroup(user.uuid, this.form._links._self.href)
                .then(() => {
                    this.usersNotInGroup = this.usersNotInGroup.filter(x => x.uuid !== user.uuid);
                    this.loadGroup(this.uuid_group);
                });
            this.$bvModal.hide(this.modalId);
        },
        /**
         * Close modal
         * @param {Object} user User
         */
        cancelChangeUser() {
            this.$bvModal.hide(this.modalId);
        }
    },
    computed: {
        /**
         * Indica si estamos editando un usuario o no
         * @return {Boolean} Editable true/false
         */
        editable() {
            if (this.actionObject('GROUPS', 'edit')) {
                if (this.$route.name === 'groups_add') {
                    return this.actionObject('GROUPS', 'add');
                }
                return this.$route.query && (this.$route.query.edit === true || (this.$route.query.edit === 'true')) ? true : false;
            }
            return false;
        },
        /**
         * @override
         */
        users() {
            return this.form.users.map(u => {
                return {
                    title: `${u.given_name} ${u.family_name_1}${u.family_name_2 ? u.family_name_2 : ''}`,
                    uuid: u.uuid
                };
            });
        }
    },
    /**
     * Carga la información del grupo si se cambia de pestaña
     * @override
     */
    beforeMount() {
        this.permissions = [];
        this.permissionSelected = null;
        this.saving = false;
        this.savingTitle = 'Guardar cambios';
        const sections = JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS'))))).sections;
        this.userSections = {
            userEdit: sections.find(x => x.key_name === 'USERS') ? sections.find(x => x.key_name === 'USERS').permission_object.value.edit : false,
            userRead: sections.find(x => x.key_name === 'USERS') ? sections.find(x => x.key_name === 'USERS').permission_object.value.read : false,
            psRead: sections.find(x => x.key_name === 'PERMISSION_SET') ? sections.find(x => x.key_name === 'PERMISSION_SET').permission_object.value.read : false,
            psEdit: sections.find(x => x.key_name === 'PERMISSION_SET') ? sections.find(x => x.key_name === 'PERMISSION_SET').permission_object.value.edit : false
        };
        // Si hay datos en el estado los cargamos
        const storedComponentData = this.getStoredComponentData();
        if (storedComponentData && Object.keys(storedComponentData).length) {
            Object.entries(storedComponentData).forEach(([key, value]) => this[key] = value);
        } else {
            this.form = { permission_set: {}, users: [], _links: {} };
        }

        if (this.$route.name !== 'groups_add') {
            // View/edit permission set
            this.fetchData();
        } else {
            this.loadCreate();
        }
    }
};
